export const API_URL = `https://car-recommendation-backend.onrender.com`;
export const SIGNUP = "api/auth/signup";
export const LOGIN = "api/auth/login";
export const USER = "api/user";
export const CAR_AUTOCOMPLETE = "api/car/autocomplete?name=";
export const CAR_RATING = "api/car/car-by-user-rating";
export const CAR_RECOMMEND_WE = "api/car/recommend/word-embeddings?index=";
export const CAR_RECOMMEND_KMEANS = "api/car/recommend/kmeans";
export const CAR_RECOMMEND_MATRIX_FACTORIZATION =
  "api/car/recommend/matrix-factorization";
